import React from 'react'
import { FiArrowRightCircle } from "react-icons/fi";
import { ImCancelCircle } from "react-icons/im";
function AC_Pricing_card() {
  return (
    <div>
    {/* -----------------Mobile View---------------- */}
    <div className='Curriculum_Containte_box pb-5 d-sm-block d-md-none'>
    <div className='container pt-5'>
        <div className='row'>
            <div className='col-md-12'>
            <div className='text-center About_Discraption_text'>
                <h1 className='display-6 pb-2'>AutoCAD Course  Fee</h1>
                <p className='fs-6'>Choose from our different pricing plans for our AutoCAD.</p>
            </div>
            </div>
        </div>
    </div>
    <div className='container'>
        <div className='col-md-12'>
        <div className='border mobile_view_pricing_card shadow bg-white  py-3'>
        <div className='px-5'>
            <h2 className='text-center  border-bottom pt-3 py-4'>Self Paced Program</h2>
        </div>
        <div className=''>
        <ul className='mt-3'>
            <div><FiArrowRightCircle  size="20px" color="#00FF00" className='d-inline mx-2'/><li className='d-inline'>Training Certificate in collaboration with </li></div>
            <div><FiArrowRightCircle  size="20px" color="white" className='d-inline mx-2'/><li className='d-inline'>NIMBUS NITH</li></div>
            <div className='pt-3'><FiArrowRightCircle  size="20px" color="#00FF00" className='d-inline mx-2'/><li className='d-inline'>Internship Certificate with our Co-</li></div>
            <div><FiArrowRightCircle  size="20px" color="white" className='d-inline mx-2'/><li className='d-inline'> Partnered  Company</li></div>
            <div className='py-3'><FiArrowRightCircle  size="20px" color="#00FF00" className='d-inline mx-2'/><li className='d-inline'>1 minor + 1 Major project</li></div>
            <div className=''><FiArrowRightCircle  size="20px" color="#00FF00" className='d-inline mx-2'/><li className='d-inline'>25+ hours of video content access</li></div>
            <div className='py-3'><ImCancelCircle   size="20px" color="red" className='d-inline mx-2'/><li className='d-inline'>16+ hours of mentor live training</li></div>
            <div className=''><ImCancelCircle  size="20px" color="red" className='d-inline mx-2'/><li className='d-inline'>Letter Of Recommendation</li></div>
            <div className='pt-3'><ImCancelCircle  size="20px" color="red" className='d-inline mx-2'/><li className='d-inline'>Outstanding Certificate of successful</li></div>
            <div><FiArrowRightCircle  size="20px" color="white" className='d-inline mx-2'/><li className='d-inline'>completion of extra projects</li></div>
            <div className='pt-3'><ImCancelCircle  size="20px" color="red" className='d-inline mx-2'/><li className='d-inline'>10+ Hours of Live Skill Development</li></div>
            <div><FiArrowRightCircle  size="20px" color="white" className='d-inline mx-2'/><li className='d-inline'>Sessions</li></div>
            </ul>
        </div>
        <div className='py-2'>
            <div className='mobile_view_pricing_background'>
            <p className='p-2 px-4'>Fee - ₹4,999 /-</p>
            </div>
        </div>
        <div className='text-center py-3'><a href='https://payments.internselite.net/traineeship/T4?method=sp'><button className="text-white shadow-sm mx-4 fs-5 px-5 pt-1 pb-2 Navbar_button">Buy Now  </button></a></div>
        </div>
        </div>
        {/* <div className='col-md-12 py-3'>
        <div className='border mobile_view_pricing_card  bg-white shadow  py-3'>
        <div className='px-5'>
            <h2 className='text-center  border-bottom pt-3 py-4'>Mentor Led Program</h2>
        </div>
        <div className=''>
        <ul className='mt-3'>
            <div><FiArrowRightCircle  size="20px" color="#00FF00" className='d-inline mx-2'/><li className='d-inline'>Training Certificate in collaboration with </li></div>
            <div><FiArrowRightCircle  size="20px" color="white" className='d-inline mx-2'/><li className='d-inline'>NIMBUS NITH</li></div>
            <div className='pt-3'><FiArrowRightCircle  size="20px" color="#00FF00" className='d-inline mx-2'/><li className='d-inline'>Internship Certificate with our Co-</li></div>
            <div><FiArrowRightCircle  size="20px" color="white" className='d-inline mx-2'/><li className='d-inline'> Partnered  Company</li></div>
            <div className='py-3'><FiArrowRightCircle  size="20px" color="#00FF00" className='d-inline mx-2'/><li className='d-inline'>1 minor + 1 Major project</li></div>
            <div className=''><FiArrowRightCircle  size="20px" color="#00FF00" className='d-inline mx-2'/><li className='d-inline'>25+ hours of video content access</li></div>
            <div className='py-3'><FiArrowRightCircle   size="20px" color="#00FF00" className='d-inline mx-2'/><li className='d-inline'>16+ hours of mentor live training</li></div>
            <div className=''><FiArrowRightCircle  size="20px" color="#00FF00" className='d-inline mx-2'/><li className='d-inline'>Letter Of Recommendation</li></div>
            <div className='pt-3'><FiArrowRightCircle  size="20px" color="#00FF00" className='d-inline mx-2'/><li className='d-inline'>Outstanding Certificate of successful</li></div>
            <div><FiArrowRightCircle  size="20px" color="white" className='d-inline mx-2'/><li className='d-inline'>completion of extra projects</li></div>
            <div className='pt-3'><FiArrowRightCircle  size="20px" color="#00FF00" className='d-inline mx-2'/><li className='d-inline'>10+ Hours of Live Skill Development</li></div>
            <div><FiArrowRightCircle  size="20px" color="white" className='d-inline mx-2'/><li className='d-inline'>Sessions</li></div>
            </ul>
        </div>
        <div className='py-2'>
            <div className='mobile_view_pricing_background'>
                <p className='p-2 px-4'>Fee - ₹7,999 /-</p>
            </div>
        </div>
        <div className='text-center py-3'><a href='https://payments.internselite.net/traineeship/T4?method=mlp'><button className="text-white shadow-sm mx-4 fs-5 px-5 pt-1 pb-2 Navbar_button">Buy Now</button></a></div>
        </div>
        </div> */}
    </div>
    </div>
    
    {/* ----------------------Desktop View------------------ */}

    <div className='Curriculum_Containte_box pb-5 d-none d-md-block'>
    <div className='container py-5'>
        <div className='row'>
            <div className='col-md-1'></div>
            <div className='col-md-10'>
            <div className='text-center About_Discraption_text'>
                <h1 className='display-5 pb-2'>AutoCAD  Course  Fee</h1>
                <p className='fs-5'>Choose from our different pricing plans for our AutoCAD</p>
            </div>
            </div>
            <div className='col-md-1'></div>
        </div>
      </div>
    <div className='container'>
      <div className='row'>
        <div className='col-md-3'></div>
        <div className='col-md-6 px-5'>
        <div className='border pricing_card shadow bg-white  py-3'>
        <div className='px-5'>
            <h2 className='text-center  border-bottom pt-3 py-4'>Self Paced Program</h2>
        </div>
        <div className='px-3'>
        <ul className=' px-4 mt-4'>
            <div><FiArrowRightCircle  size="20px" color="#00FF00" className='d-inline mx-2'/><li className='d-inline'>Training Certificate in collaboration with </li></div>
            <div><FiArrowRightCircle  size="20px" color="white" className='d-inline mx-2'/><li className='d-inline'>NIMBUS NITH</li></div>
            <div className='pt-3'><FiArrowRightCircle  size="20px" color="#00FF00" className='d-inline mx-2'/><li className='d-inline'>Internship Certificate with our Co-Partnered </li></div>
            <div><FiArrowRightCircle  size="20px" color="white" className='d-inline mx-2'/><li className='d-inline'> Company</li></div>
            <div className='py-3'><FiArrowRightCircle  size="20px" color="#00FF00" className='d-inline mx-2'/><li className='d-inline'>1 minor + 1 Major project</li></div>
            <div className=''><FiArrowRightCircle  size="20px" color="#00FF00" className='d-inline mx-2'/><li className='d-inline'>25+ hours of video content access</li></div>
            <div className='py-3'><ImCancelCircle   size="20px" color="red" className='d-inline mx-2'/><li className='d-inline'>16+ hours of mentor live training</li></div>
            <div className=''><ImCancelCircle   size="20px" color="red" className='d-inline mx-2'/><li className='d-inline'>10+ Hours of Live Skill Development Sessions</li></div>
            <div className='py-3'><ImCancelCircle  size="20px" color="red" className='d-inline mx-2'/><li className='d-inline'>Letter Of Recommendation</li></div>
            <div className=''><ImCancelCircle  size="20px" color="red" className='d-inline mx-2'/><li className='d-inline'>Outstanding Certificate of successful</li></div>
            <div><FiArrowRightCircle  size="20px" color="white" className='d-inline mx-2'/><li className='d-inline'>completion of extra projects</li></div>
        </ul>
        </div>
        <div className='py-2'>
            <div className='pricing_background'>
            <p className='px-4 py-2'>Fee - ₹4,999 /-</p>
            </div>
        </div>
        <div className='text-center py-3'><a href='https://payments.internselite.net/traineeship/T4?method=sp'><button className="text-white shadow-sm mx-4 fs-5 px-5 pt-1 pb-2 Navbar_button">Buy Now  </button></a></div>
        </div>
        </div>
        {/* <div className='col-md-5 px-5'>
        <div className='border pricing_card  bg-white shadow  py-3'>
        <div className='px-5'>
            <h2 className='text-center  border-bottom pt-3 py-4'>Mentor Led Program</h2>
        </div>
        <div className='px-3'>
        <ul className=' px-4 mt-4'>
            <div><FiArrowRightCircle  size="20px" color="#00FF00" className='d-inline mx-2'/><li className='d-inline'>Training Certificate in collaboration with </li></div>
            <div><FiArrowRightCircle  size="20px" color="white" className='d-inline mx-2'/><li className='d-inline'>NIMBUS NITH</li></div>
            <div className='pt-3'><FiArrowRightCircle  size="20px" color="#00FF00" className='d-inline mx-2'/><li className='d-inline'>Internship Certificate with our Co-Partnered </li></div>
            <div><FiArrowRightCircle  size="20px" color="white" className='d-inline mx-2'/><li className='d-inline'> Company</li></div>
            <div className='py-3'><FiArrowRightCircle  size="20px" color="#00FF00" className='d-inline mx-2'/><li className='d-inline'>1 minor + 1 Major project</li></div>
            <div className=''><FiArrowRightCircle  size="20px" color="#00FF00" className='d-inline mx-2'/><li className='d-inline'>25+ hours of video content access</li></div>
            <div className='py-3'><FiArrowRightCircle   size="20px" color="#00FF00" className='d-inline mx-2'/><li className='d-inline'>16+ hours of mentor live training</li></div>
            <div className=''><FiArrowRightCircle   size="20px" color="#00FF00" className='d-inline mx-2'/><li className='d-inline'>10+ Hours of Live Skill Development Sessions</li></div>
            <div className='py-3'><FiArrowRightCircle  size="20px" color="#00FF00" className='d-inline mx-2'/><li className='d-inline'>Letter Of Recommendation</li></div>
            <div className=''><FiArrowRightCircle  size="20px" color="#00FF00" className='d-inline mx-2'/><li className='d-inline'>Outstanding Certificate of successful</li></div>
            <div><FiArrowRightCircle  size="20px" color="white" className='d-inline mx-2'/><li className='d-inline'>completion of extra projects</li></div>
            </ul>
        </div>
        <div className='py-2'>
            <div className='pricing_background'>
                <p className='px-4 py-2'>Fee - ₹7,999 /-</p>
            </div>
        </div>
        <div className='text-center py-3'><a href='https://payments.internselite.net/traineeship/T4?method=mlp'><button className="text-white shadow-sm mx-4 fs-5 px-5 pt-1 pb-2 Navbar_button">Buy Now</button></a></div>
        </div>
        </div> */}
        <div className='col-md-3'></div>
      </div>
    </div>
    </div>
    </div>
  )
}

export default AC_Pricing_card
